import axios from "axios"
import router from './router'
import store from './store'


export default () => {

  router.onReady(() => {
    const anteriorDB = localStorage.getItem("KEY") || 0
    store.commit('SET_DATABASE', router.currentRoute.params.database)
    localStorage.setItem("KEY", store.state.DATA_BASE)
    const CARRITO = JSON.parse(localStorage.getItem("CARRITO" + store.state.DATA_BASE) || '[]')
    store.commit('SET_CARRITO_ARRAY', CARRITO)
    if (localStorage.getItem("CLIENTE")) {
      if (anteriorDB != store.state.DATA_BASE) {
        localStorage.removeItem('CLIENTE')
      } else {
        const CLIENTE = JSON.parse(window.atob(localStorage.getItem("CLIENTE")))
        store.commit('SET_CLIENTE', CLIENTE)
      }
    } else {
      store.commit('SET_CLIENTE', {
        ciudad: {
          departamento: {}
        }
      })
    }
    axios.interceptors.request.use(config => {
      config.headers.database = store.state.DATA_BASE
      return config
    }, err => {
      return Promise.reject(err) - l
    })

    if (router.currentRoute.name !== 'home') {
      axios.get('/go-empresa').then(({ data }) => {
        // console.log(data);
        if (data.serial) {
          router.push(`/${store.state.DATA_BASE}/fuera-servicio`)
        } else {
          store.commit('SET_EMPRESA', data)
          if (data.bodegas) {
            axios.get("/go-grupos/bodegas").then((data_bodegas) => {
              const data_bdgs = data_bodegas.data
              store.commit('SET_BODEGAS', data_bdgs)
            })
          }
        }
      }).catch((err) => {
        console.dir(err);
      });
    }
  })
}